import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;
const SITE_CODE = process.env.REACT_APP_SITE_CODE;

export const getEarthquakeInformation = (callback) => {
  axios
    .get(`${API_URL}/api/analysis/get_earthquake_information/${SITE_CODE}`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};
